import { useContext } from "react"
import userContext from "src/context/userContext"
import SuperAdminDashboard from "./SuperAdminDashboard";
import SellerDashboard from "./SellerDashboard/SellerDashboard";


export default function MainDashboard() {
    const { user } = useContext(userContext)

    switch (user?.role?.role) {
        case "superAdmin":
            return (
                <>
                    <SuperAdminDashboard />
                </>
            )
        case "seller":
            return (
                <>
                    <SellerDashboard />
                </>
            )
        default:
            return (
                <>
                </>
            )
    }
}
